import * as useStartersData from '@core/Areas/Racing/Hooks/useStartersData'
import { getRacePageDataFromApi } from '@core/Areas/Racing/api'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { queryClient } from '@core/Data/ReactQuery/queryClient'
import Mapper from '../Mapping/Mappers'
import type { IObservablePage } from '../Model/Observables/IObservablePage'

export const StartersReactQueryService = {
  async retrieveCompleteRace(
    meetingId: string,
    raceNumber: number,
    meetingDate: Date
  ): Promise<IObservablePage> {
    const pageDto = await queryClient.fetchQuery({
      queryKey: [queryKeys.racePageComplete(meetingId, meetingDate, raceNumber)],
      queryFn: () => getRacePageDataFromApi(meetingId, meetingDate, raceNumber),
    })
    const page = Mapper.map(pageDto)
    return page
  },

  async retrieveStartersForRaces(
    meetingId: string,
    meetingDate: Date,
    raceNumbers: number[]
  ): Promise<IObservablePage> {
    const { queryKey, queryFn } = useStartersData
    const pageDto = await queryFn(meetingId, meetingDate, raceNumbers)
    queryClient.setQueryData([queryKey(meetingId, meetingDate, raceNumbers)], pageDto)
    return Mapper.map(pageDto)
  },
}
